
import styles from "./TestCaseUser.module.scss";
import { useTranslation } from 'react-i18next'
import { useState } from "react";
import Notification from "utils/Notifications";
import PartWorkAdminUsed from "./components/PartWorkAdminUsed"
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
const TestCaseUserLose = ({ title_dat, item, index, setRender, partUserTests, partWorkTests }) => {
  const { t } = useTranslation('common')

 const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });


    const [showUserInfo_det, setShowUserInfoForm] = useState(null);
    const [partUserTests_det, setPartUserTests_det] = useState(null);
    const handleShowForm = (id) => {
        const filteredData = (partUserTests || []).find(item => item.id === id);

        setShowUserInfoForm(id);
        setPartUserTests_det(filteredData)
    };


    return (
        <>
        <button className={styles.btn_print} onClick={handlePrint}>{t('auto.components_academicyearcontent.k1')} </button>
        <div  ref={componentRef}  className={styles.test_card}>
        <div className={styles.div_print}><h4>Отчет по тесту: {title_dat} </h4><h4>Дата отчета: {new Date().toLocaleString("ru-RU")}</h4> </div>   
            {showUserInfo_det === null ? (
                <>
                    <div className="table-container">
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr>

                                    <th className={styles.test_row_title}>№</th>
                                    <th className={styles.test_row_title}>{t('archive.lbl_user')}</th>
                                    <th className={styles.test_row_title}>{t('pages.employeeWizard.start_date')}</th>
                                
                                </tr>
                            </thead>
                            <tbody>
                                {partUserTests.map((item, index) =>
                               
                                    <tr className={styles.tr_element} onClick={() => handleShowForm(item.id)} style={{ backgroundColor: item.admin_checked === true ? '#ffe8e8' : "#fff" }}>
                                         <td className={styles.test_row_title}>{index + 1}</td>
                                        <td className={styles.test_row_title} style={{textAlign:"left"}}><>{item.employee_name ? item.employee_name : item.full_name}</></td>
                                        <td className={styles.test_row_title}><>{item.createdAt}</></td>
                                      
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
            ) : (<>
                <div className="table-container">
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr>
                                <th className={styles.test_row_title}>{t('archive.lbl_user')}</th>
                                <th className={styles.test_row_title}>{t('pages.employeeWizard.start_date')}</th>
                                
                            </tr>
                        </thead>
                        <tbody>

                            <tr >
                                <td className={styles.test_row_title}><>{partUserTests_det.employee_name ? partUserTests_det.employee_name : partUserTests_det.full_name}</></td>
                                <td className={styles.test_row_title}><>{partUserTests_det.createdAt}</></td>
                               
                            </tr>

                        </tbody>
                    </table>
                </div>
                <PartWorkAdminUsed setShowUserInfoForm={setShowUserInfoForm} data={partWorkTests} usedata={partUserTests_det} setRender={setRender} />
            </>
            )

            }


            <Notification notify={notify} setNotify={setNotify} />
        </div >


</>

    );
};

export default TestCaseUserLose;
